import api from './api'

const organizationService = {}

organizationService.acceptInvitation = payload =>
  api.put('/organizations/accept-invitation', payload)

export default organizationService
